interface TextAreaProps {
  id: string;
  label: string;
  placeholder?: string;
  helper?: string;
  required: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
}

import { RequiredMark, exploreLabelClass, exploreTextAreaClass } from '@/components/explore/explore-form-fields';

const labelClass = exploreLabelClass;
const textareaClass = exploreTextAreaClass;

export const TextArea = ({ id, label, placeholder, helper, required, value, onChange, rows = 4 }: TextAreaProps) => {
  return (
    <div>
      <label htmlFor={id} className={labelClass}>
        {required && <RequiredMark />}
        {label}
      </label>
      <textarea
        id={id}
        name={id}
        required={required}
        value={value}
        onChange={onChange}
        rows={rows}
        className={textareaClass}
        placeholder={placeholder}
      />
      {helper && <p className="mt-1.5 text-xs font-light text-muted">{helper}</p>}
    </div>
  );
};
